<template>

	<div class="row" v-if="clubRecords.length > 0">
		<div class="panel panel-primary">
		    <div class="panel-heading">
				<h3 class="panel-title">{{ tableTitle }}</h3>
		    </div>
			<el-table
				:data = "clubRecords"
				ref="clubRecordTable"
				border
				stripe
				class="table table-bordered table-striped"
				highlight-current-row
				style="width: 100%"
			>

			    <el-table-column
			    	v-if="canManageRecords"
			    	class="row-actions"
			      label="Actions">
			      <template slot-scope="scope">
			        <el-button
			          size="mini"
			          type="danger"
			          class="btn btn-danger btn-sm"
			          @click="handleDelete(scope.$index, scope.row)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></el-button>
			      </template>
			    </el-table-column>

				<el-table-column
			      prop="full_name"
			      label="Name"
			      sortable
			      >
			    </el-table-column>


				<el-table-column
			      prop="gender"
			      label="Gender"
			      sortable
			      :filters="[{ text: 'Male', value: 'Male'}, { text: 'Female', value: 'Female'} ]"
			      :filter-method="filterGender"
			      >
			    </el-table-column>
				<el-table-column
			      prop="event.name"
			      label="Event"
			      :filters="eventFilterOptions"
			      :filter-method="filterEvent"
			      sortable
			      :sort-method="sortEvent"
			      >
			    </el-table-column>
				<el-table-column
			      prop="age_group.name"
			      label="Age Group"
			      sortable
			      :filters="ageGroupFilterOptions"
			      :filter-method="filterAgeGroup"
			      sort-by="age_group.min_age"
			      >
			    </el-table-column>
				<el-table-column
			      prop="course"
			      label="Course"
			      sortable
			      :filters="[{ text: 'SC', value: 'SC'}, { text: 'LC', value: 'LC'} ]"
			      :filter-method="filterCourse"
			      >
			    </el-table-column>
				<el-table-column
			      prop="swim_date"
			      label="Date"
			      :formatter="elFormatDate"
			      sortable
			      >
			    </el-table-column>
				<el-table-column
			      prop="swim_time"
			      label="Swim Time"
			      sortable
			      >
			    </el-table-column>


			</el-table>


		</div>


	</div>


	
</template>
<script>

    import _ from 'lodash';
	import { Table } from 'element-ui';
	import lang from 'element-ui/lib/locale/lang/en';
	import locale from 'element-ui/lib/locale';

	locale.use(lang);

	export default {
		components: { Table },
        props: {
            gender: {
                type: String,
                default: ""
            },
            course: {
                type: String,
                default: ""
            },
            title: {
                type: String,
                default: "Club Records"
            },
            can_manage_records: {
            	type: Boolean,
            	default: false
            }
        },
		data: function () {
				return {
					filterAPIDataGender: this.gender,
					filterAPIDataCourse: this.course,
					tableTitle: this.title,
					canManageRecords: this.can_manage_records,
					ageGroupFilterOptions: null,
					eventFilterOptions: null,
					clubRecords: []
				}
		},
		computed: {
            recordFilters : function() {
                var filters = [];
                // 'training_date:2018-01-01~~2018-03-01&format=chartjs'
                // We always have a date range filter
                if (this.filterAPIDataGender != "") {
                    filters.push('gender:' + this.filterAPIDataGender);
                }
                if (this.filterAPIDataCourse != "") {
                    filters.push('course:' + this.filterAPIDataCourse);
                }
                return 'filters=' + filters.join();
            }
		},
		mounted() {
			console.log('Club Records List component mounted.');
			this.getClubRecords();
			window.eventBus.$on('add-new-club-record', this.getClubRecords);
		},
		methods: {
            getClubRecords() {
				console.log('getClubRecords');
				// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
				axios.get('/api/v1/club_records?'+ this.recordFilters).then((response) => {
					// this.loadingInstance.close();
					console.log(response.data);
					this.clubRecords = response.data;
					this.setAgeGroupFilterOptions();
					this.setEventFilterOptions();
				}).catch((error) => {
					// this.loadingInstance.close();
					console.log(error);
					this.$message({message: 'There was a problem loading club records.', type: 'error'});
				});
			},
			formatDate(theDate) {
				return moment(theDate).format("DD/MM/YYYY")
			},

			elFormatDate(row, column) {
				return moment(row.swim_date).format("DD/MM/YYYY")
			},
			getClubRecordsGrouped() {

			},
			setAgeGroupFilterOptions() {
				var ageGroupFilterOptions = _.sortBy(this.clubRecords,  ['age_group.min', 'age_group.max']).map(function(clubRecord)
				{ 
					console.log(clubRecord.age_group.id);
					console.log(clubRecord.age_group.name);
					return { text: clubRecord.age_group.name, value: clubRecord.age_group.id};
				});
				this.ageGroupFilterOptions = _.uniqBy(ageGroupFilterOptions,'value');

			},
			setEventFilterOptions() {
				var eventFilterOptions = _.sortBy(this.clubRecords,['event.stroke', 'event.distance']).map(function(clubRecord)
				{ 
					console.log(clubRecord.event.id);
					console.log(clubRecord.event.name);
					return { text: clubRecord.event.name, value: clubRecord.event.id, stroke: clubRecord.event.stroke, distance: clubRecord.event.distance};
				});
				this.eventFilterOptions = _.uniqBy(eventFilterOptions, 'value');
			},
			filterGender(value, row) {
				return row.gender === value;
			},
			filterCourse(value, row) {
				return row.course === value;
			},
			filterAgeGroup(value,row) {
				return row.age_group.id === value;
			},
			filterEvent(value, row) {
				return row.event.id === value;
			},
			handleDelete(index, record) {
				console.log('Deleting record: ' + record.id);
				axios.delete('/api/v1/club_record/' + record.id).then((response) => {
					// this.loadingInstance.close();
					console.log(response.data);
					this.clubRecords = response.data;
					this.getClubRecords();
					this.$refs.clubRecordTable.doLayout();
					this.$message({message: 'The record has been deleted.', type: 'success'});
				}).catch((error) => {
					// this.loadingInstance.close();
					this.$message({message: 'There was a problem deleting the record.', type: 'error'});
				});
			},
			sortEvent(a, b) {
		        if (a.event.stroke == b.event.stroke) {
		        	if (a.event.distance > b.event.distance) {
		        		return 1;
		        	}
		        	else if (a.event.distance < b.event.distance) {
		        		return -1
		        	}
		        }
		        else if (a.event.stroke > b.event.stroke) {
		        	return 1;
		        }
		        else if (a.event.stroke < b.event.stroke) {
		        	return -1;
		        }
		        return 0;
		      }
		}
	}
</script>